import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Tracking from "../pages/tracking/page";
import TopicDetail from "../pages/topic/page";
import About from "../pages/about/page";
import SiteLayout from "../components/feature/SiteLayout";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <SiteLayout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "tracking",
        element: <Tracking />,
      },
      {
        path: "topic/:slug",
        element: <TopicDetail />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
];

export default routes;